import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone, PlanzoneSettings } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editPlanzoneSettings(
    credentials: Boundaries["editPlanzoneSettings"]["request"],
  ): void;
}

function useEditPlanzoneSettings(planzone: Identifiable<Planzone>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditPlanzoneSettingsRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditPlanzoneSettingsRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditPlanzoneSettingsRequestFailure(planzone),
    ),
    editPlanzoneSettings: core.editPlanzoneSettings,
  };
}

export { useEditPlanzoneSettings };
